export default {
  error: {
    tooBig: 'The file is too large (maximum: {maxSize} {unit})'
  }
}
